import "@fortawesome/fontawesome-free/css/all.min.css";
import { createBrowserRouter, createRoutesFromElements, Route } from "react-router-dom";
import { ConsultForm } from "./pages/consultForm";
import { ConsultLiff } from "./pages/consultLiff";
import Article from "pages/article";
import Consulting from "pages/consulting";
import InfoList from "pages/infoList";
import ClinicList from "pages/clinicList";
import Profile from "pages/profile";

export const router = createBrowserRouter(
  createRoutesFromElements(
    <>
      <Route path="/clinicList" element={<ClinicList />} />
      <Route path="/consultForm" element={<ConsultForm />} />
      <Route path="/consultLiff110" element={<ConsultLiff />} />
      <Route path="/consulting" element={<Consulting />} />
      <Route path="/infoList" element={<InfoList />} />
      <Route path="/infoList/:articleId" element={<Article />} />
      <Route path="/profile" element={<Profile/>} />
    </>
  )
);